import { makeStyles, Theme } from "@material-ui/core/styles";
import React, { forwardRef, useCallback, useEffect, useMemo } from "react";

// import { useTranslation } from "react-i18next";
import { Card } from "@material-ui/core";
import { Typography, Avatars } from "@thingsw/pitta-design-system";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { useSelector } from "react-redux";
import { CAMERA } from "../../features/Camera/slice";
import { RootState } from "../../features/store";
import {
  AvailableFws,
  DashCamList,
  ICameraInfo,
  LightColors,
} from "@thingsw/pitta-modules";
import { RenewalCameraItem } from "../renewal2/RenewalCameraItem";
import { APP_MENU } from "../../screens/app/renewal2/RenewalMapviewScreen";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) => ({
  root: (props: CameraInfoProps) => ({
    minHeight: "fit-content",
    margin: "4px 16px",
    ...(props.disabled
      ? {
          cursor: "auto",
          opacity: 0.35,
          "&:hover div": {
            backgroundColor: LightColors.primary["0"],
          },
          "&:active div": {
            backgroundColor: LightColors.primary["0"],
          },
          "&:hover": {
            // color: LightColors.primary["3"],
          },
        }
      : {}),
    borderRadius: 16,
    boxShadow: `-2px 2px 12px -4px rgb(0 0 0 / 12%), 0px 2px 16px -4px rgb(0 0 0 / 16%)`,
  }),
  rootTransition: {
    transition: theme.transitions.create(["transform", "height"]),
    userSelect: "none",
  },
  profile: {
    padding: "16px 12px 8px",
    // mantis 10483, 피그마 간격 적용하여 marginInlineEnd: 8->4로 변경 (Leehj)
    marginInlineEnd: 4,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  avatar: {
    display: "flex",
    flexDirection: "row",
  },
  cameraCountDiv: {
    display: "flex",
    flexDirection: "column",
    padding: "0 8px",
    justifyContent: "center",
  },
  icon: {
    display: "block",
  },
  moreBtn: {
    padding: 0,
  },
  status: {
    // mantis 10483, 피그마 간격 적용하여 padding변경 (Leehj)
    padding: "12px 16px 16px",
    // padding: "12px 21px 16px",
    display: "flex",
    justifyContent: "space-between",
  },
  noti: {
    display: "flex",
    alignItems: "center",
  },
  groupTitle: {
    ...(theme.direction === "rtl"
      ? {
          marginLeft: 6,
          marginRight: 8,
        }
      : { marginLeft: 8, marginRight: 6 }),
  },
  divider: {
    margin: "0 12px",
    height: 1.6,
    background: LightColors.primary["6"],
    borderRadius: 2,
    width: 32,
  },
  avatarMulti: {
    width: 16,
    height: 16,
    position: "absolute",
    border: "1px solid #FFFFFF",
    borderRadius: "50%",
  },
  avatarMulti2: {
    width: 25,
    height: 25,
    position: "absolute",
    borderRadius: "50%",
  },
  noCamGroup: {
    width: 44,
    height: 44,
    border: `2px solid ${LightColors.primary["9"]}`,
    borderRadius: "50%",
    backgroundColor: LightColors.primary["10"],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  noCamGroupIcon: {
    color: LightColors.primary["8"],
  },
  camList: {
    backgroundColor: LightColors.primary["5"],
  },
  oneCamList: {
    height: 224,
  },
  openGroupHead: {
    backgroundColor: LightColors.primary["0"],
    zIndex: 105,
  },
  groupHead: {
    backgroundColor: LightColors.primary["0"],

    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    boxShadow: `0px -2px 12px -4px rgb(0 0 0 / 12%), 0px -2px 16px -4px rgb(0 0 0 / 16%)`,
    // boxShadow: `-2px 2px 12px -4px rgb(0 0 0 / 12%), 0px 2px 16px -4px rgb(0 0 0 / 16%)`,
  },
  cameraItem: {
    margin: "8px 10px",
    width: "calc(100% - 20px) !important",
  },
  panelClose: {
    height: 0,
  },
}));

export interface CameraInfoProps {
  group: DashCamList;

  onClickMore: (device: ICameraInfo) => void;
  handleMenu: (camera: ICameraInfo, Menu: APP_MENU) => void;
  handleMoveTop: (cardRef: any) => void;
  handleMobileMoveTop: (cardRef: any) => void;
  onClick?: (group: DashCamList) => void;
  newFw?: boolean;
  disabled?: boolean;

  style?: React.CSSProperties;
  iconStyle?: React.CSSProperties;
  connectivityStyle?: React.CSSProperties;
  availableNewFws: AvailableFws;
  settingsCamPerm: boolean;
  fotaCamPerm: boolean;
  buttonsRef: React.MutableRefObject<{
    [key: string]: React.RefObject<HTMLDivElement>;
  }>;
  simpleBarRef: React.RefObject<any>;
  camListRef: React.RefObject<HTMLDivElement>;
  searchKey: string;
  mobile?: boolean;
}

export const FleetaCameraGroup = forwardRef<HTMLButtonElement, CameraInfoProps>(
  (props) => {
    const {
      group,
      style,
      availableNewFws,
      onClickMore,
      buttonsRef,
      handleMenu,
      handleMoveTop,
      handleMobileMoveTop,
      simpleBarRef,
      camListRef,
      searchKey,
      mobile,
    } = props;
    const classes = useStyles(props);
    const { t } = useTranslation();
    const [open, setOpen] = React.useState(false);
    const [cameraCardExtraHeight, setCameraCardExtraHeight] = React.useState<
      {
        psn: string;
        height: number;
      }[]
    >([]);
    const [showFixedHeader, setShowFixedHeader] = React.useState(false);
    const cardRef = React.useRef<HTMLDivElement>(null);
    const [isAbsoluteHeader, setIsAbsoluteHeader] = React.useState(false);
    const [isSetSearchGroupHeader, setIsSetSearchGroupHeader] = React.useState(
      false
    );
    const [isInitSearch, setIsInitSearch] = React.useState(
      searchKey ? true : false
    );

    const { cameraList } = useSelector((state: RootState) => state[CAMERA]);

    const dashCamCount = useMemo(() => {
      return group.DashCamUser?.length || 0;
    }, [group.DashCamUser?.length]);

    const groupCams = useMemo(() => {
      return _.filter(
        cameraList?.deviceListInfo,
        (dev) => dev.device.reg_category !== "wifi"
      );
    }, [cameraList?.deviceListInfo]);

    const filteredCams = useMemo(() => {
      const cams = _.filter(
        groupCams,
        (d) =>
          d.groupManagementID === group.GroupID &&
          (d.device.dev_name
            .toLowerCase()
            .includes(searchKey.trim().toLowerCase()) ||
            d.device.psn.toLowerCase().includes(searchKey.trim().toLowerCase()))
      );

      if (cams.length === 0) {
        return _.filter(
          groupCams,
          (d) => d.groupManagementID === group.GroupID
        );
      } else {
        return cams;
      }
    }, [group.GroupID, groupCams, searchKey]);

    const avartarDivWidth = useMemo(() => {
      const cams = _.filter(
        groupCams,
        (d) => d.groupManagementID === group.GroupID
      );

      if (cams.length === 1) {
        return 28;
      } else if (cams.length === 2) {
        return 40;
      } else if (cams.length === 3) {
        return 52;
      } else {
        return 64;
      }
    }, [group.GroupID, groupCams]);

    const cameraCountText = useMemo(() => {
      // mantis - 10483, 할당된 카메라 없는 경우 0 Cameras로 출력 (Leehj)
      if (!group.DashCamUser) return `0 ${t("Cameras")}`;

      const cams = _.filter(
        groupCams,
        (d) => d.groupManagementID === group.GroupID
      );

      if (cams.length === 1) {
        return `${cams.length} ${t("Camera")}`;
      }
      return `${cams.length} ${t("Cameras")}`;
    }, [group.DashCamUser, group.GroupID, groupCams, t]);

    const avatarMarkup = useMemo(() => {
      const firstAvatar = _.find(
        groupCams,
        (dev) =>
          dev.device.psn === group.DashCamUser?.[0]?.PSN &&
          dev.device.reg_category !== "wifi"
      )?.device;

      // if (group.DashCamUser.length === 1) {
      //   return (
      //     <Avatars
      //       name={group.GroupName}
      //       style={{ width: 44, height: 44 }}
      //       imgSrc={firstAvatar?.profile_img || undefined}
      //     />
      //   );
      // }
      const secondsAvatar = _.find(
        groupCams,
        (dev) =>
          dev.device.psn === group.DashCamUser?.[1]?.PSN &&
          dev.device.reg_category !== "wifi"
      )?.device;
      const thirdAvatar = _.find(
        groupCams,
        (dev) =>
          dev.device.psn === group.DashCamUser?.[2]?.PSN &&
          dev.device.reg_category !== "wifi"
      )?.device;
      const fourthAvatar = _.find(
        groupCams,
        (dev) =>
          dev.device.psn === group.DashCamUser?.[3]?.PSN &&
          dev.device.reg_category !== "wifi"
      )?.device;

      const noneAvatar = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_67_2062)">
            <rect width="24" height="24" fill="white" />
            <ellipse cx="12" cy="11.9999" rx="12" ry="11.9999" fill="white" />
            <path
              d="M8.47995 17.6277C8.13196 17.3493 7.9837 16.9019 8.06253 16.4633C8.20398 15.6764 8.58893 14.9448 9.17353 14.3721C9.92367 13.6373 10.9411 13.2245 12.002 13.2245C13.0628 13.2245 14.0802 13.6373 14.8304 14.3721C15.415 14.9448 15.7999 15.6764 15.9414 16.4633C16.0202 16.9019 15.8719 17.3493 15.524 17.6277C14.9663 18.0738 13.8732 18.6666 12.002 18.6666C10.1307 18.6666 9.03763 18.0738 8.47995 17.6277ZM12.002 12.7347C10.3445 12.7347 9.00195 11.4196 9.00195 9.79593C9.00195 8.17227 10.3445 6.85718 12.002 6.85718C13.6594 6.85718 15.0019 8.17227 15.0019 9.79593C15.0019 11.4196 13.6594 12.7347 12.002 12.7347Z"
              fill="#61007D"
            />
            <circle
              cx="12"
              cy="12"
              r="11.2"
              stroke="#E9E9EA"
              strokeWidth="1.6"
            />
          </g>
          <defs>
            <clipPath id="clip0_67_2062">
              <rect width="24" height="24" rx="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

      if (firstAvatar && secondsAvatar && thirdAvatar && fourthAvatar) {
        return (
          <>
            {firstAvatar?.profile_img_v2.includes("json") ? (
              <div
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 0 }}
              >
                {noneAvatar}
              </div>
            ) : (
              <Avatars
                mode="camera"
                name={firstAvatar?.dev_name}
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 0 }}
                imgSrc={firstAvatar?.profile_img_v2 || undefined}
              />
            )}
            {secondsAvatar?.profile_img_v2.includes("json") ? (
              <div
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 12 }}
              >
                {noneAvatar}
              </div>
            ) : (
              <Avatars
                mode="camera"
                name={secondsAvatar?.dev_name}
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 12 }}
                imgSrc={secondsAvatar?.profile_img_v2 || undefined}
              />
            )}
            {thirdAvatar?.profile_img_v2.includes("json") ? (
              <div
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 24 }}
              >
                {noneAvatar}
              </div>
            ) : (
              <Avatars
                mode="camera"
                name={thirdAvatar?.dev_name}
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 24 }}
                imgSrc={thirdAvatar?.profile_img_v2 || undefined}
              />
            )}
            {fourthAvatar?.profile_img_v2.includes("json") ? (
              <div
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 36 }}
              >
                {noneAvatar}
              </div>
            ) : (
              <Avatars
                mode="camera"
                name={fourthAvatar?.dev_name}
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 36 }}
                imgSrc={fourthAvatar?.profile_img_v2 || undefined}
              />
            )}
          </>
        );
      }

      if (firstAvatar && secondsAvatar && thirdAvatar) {
        return (
          <>
            {firstAvatar?.profile_img_v2.includes("json") ? (
              <div
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 0 }}
              >
                {noneAvatar}
              </div>
            ) : (
              <Avatars
                mode="camera"
                name={firstAvatar?.dev_name}
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 0 }}
                imgSrc={firstAvatar?.profile_img_v2 || undefined}
              />
            )}
            {secondsAvatar?.profile_img_v2.includes("json") ? (
              <div
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 12 }}
              >
                {noneAvatar}
              </div>
            ) : (
              <Avatars
                mode="camera"
                name={secondsAvatar?.dev_name}
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 12 }}
                imgSrc={secondsAvatar?.profile_img_v2 || undefined}
              />
            )}
            {thirdAvatar?.profile_img_v2.includes("json") ? (
              <div
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 24 }}
              >
                {noneAvatar}
              </div>
            ) : (
              <Avatars
                mode="camera"
                name={thirdAvatar?.dev_name}
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 24 }}
                imgSrc={thirdAvatar?.profile_img_v2 || undefined}
              />
            )}
          </>
        );
      } else if (firstAvatar && secondsAvatar) {
        return (
          <>
            {firstAvatar?.profile_img_v2.includes("json") ? (
              <div
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 0 }}
              >
                {noneAvatar}
              </div>
            ) : (
              <Avatars
                mode="camera"
                name={firstAvatar?.dev_name}
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 0 }}
                imgSrc={firstAvatar?.profile_img_v2 || undefined}
              />
            )}
            {secondsAvatar?.profile_img_v2.includes("json") ? (
              <div
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 12 }}
              >
                {noneAvatar}
              </div>
            ) : (
              <Avatars
                mode="camera"
                name={secondsAvatar?.dev_name}
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 12 }}
                imgSrc={secondsAvatar?.profile_img_v2 || undefined}
              />
            )}
          </>
        );
      } else {
        return (
          <>
            {firstAvatar?.profile_img_v2.includes("json") ? (
              <div
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 0 }}
              >
                {noneAvatar}
              </div>
            ) : (
              <Avatars
                mode="camera"
                name={firstAvatar?.dev_name}
                className={classes.avatarMulti2}
                style={{ bottom: 6, left: 0 }}
                imgSrc={firstAvatar?.profile_img_v2 || undefined}
              />
            )}
          </>
        );
      }
    }, [classes.avatarMulti2, group.DashCamUser, groupCams]);

    useEffect(() => {
      if (searchKey && filteredCams.length === groupCams.length) {
        setOpen(false);
      } else if (searchKey && filteredCams.length < groupCams.length) {
        setOpen(true);
      }
    }, [filteredCams.length, groupCams.length, searchKey]);

    useEffect(() => {
      if (dashCamCount === 1) {
        return;
      }

      if (open) {
        // 검색 결과로 처음 카메라 그룹이 노출되었을 때 고정 헤더를 출력하지 않음
        if (isInitSearch) {
          setIsInitSearch(false);
          return;
        }

        setTimeout(() => setShowFixedHeader(true), 300);
      } else {
        setShowFixedHeader(false);
      }
      // initSerach가 변경될 때 다시 실행되지 않도록 의도적으로 eslint-disable-next-line 추가
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dashCamCount, open]);

    useEffect(() => {
      const parent = mobile
        ? camListRef?.current
        : simpleBarRef?.current?.getScrollElement();
      const child = cardRef?.current;

      if (parent && child && open && dashCamCount > 1) {
        const handleScroll = () => {
          // 부모 요소의 스크롤 위치
          const parentScrollTop = parent.scrollTop;
          // 자식 요소의 offsetTop (부모 요소의 top으로부터의 거리)
          const childOffsetTop = child.offsetTop;
          // 자식 요소의 현재 스크롤 위치 계산
          const childScrollPosition = childOffsetTop - parentScrollTop;

          const unfixedHeaderPoint = mobile ? 0 : 0;

          if (searchKey && childScrollPosition < 0) {
            setIsSetSearchGroupHeader(true);
          } else {
            setIsSetSearchGroupHeader(false);
          }

          if (childScrollPosition > unfixedHeaderPoint) {
            setShowFixedHeader(false);
          } else {
            setShowFixedHeader(true);
          }
        };

        // 스크롤 이벤트 리스너 추가
        parent.addEventListener("scroll", handleScroll);

        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return () => {
          parent.removeEventListener("scroll", handleScroll);
        };
      }
    }, [camListRef, dashCamCount, mobile, open, searchKey, simpleBarRef]);

    useEffect(() => {
      const parent = mobile
        ? camListRef?.current
        : simpleBarRef?.current?.getScrollElement();

      if (parent && open && dashCamCount > 1) {
        const handleLastChildScroll = () => {
          // 부모 요소의 스크롤 위치
          const parentScrollTop = parent.scrollTop;
          // 자식 요소의 offsetTop (부모 요소의 top으로부터의 거리)
          const lastChildOffsetTop =
            buttonsRef?.current[
              filteredCams[filteredCams.length - 1].device.psn
            ]?.current?.offsetTop || 0;

          // 자식 요소의 현재 스크롤 위치 계산
          const childScrollPosition = lastChildOffsetTop - parentScrollTop;

          if (childScrollPosition < 115) {
            setIsAbsoluteHeader(true);
          } else {
            setIsAbsoluteHeader(false);
          }
        };

        // 스크롤 이벤트 리스너 추가
        parent.addEventListener("scroll", handleLastChildScroll);

        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return () => {
          parent.removeEventListener("scroll", handleLastChildScroll);
        };
      }
    }, [
      buttonsRef,
      camListRef,
      dashCamCount,
      filteredCams,
      mobile,
      open,
      simpleBarRef,
    ]);

    const headerOffsetAdjustment = useMemo(() => {
      if (mobile) {
        return 64;
      } else {
        return 134;
      }
    }, [mobile]);

    const searchGroupHeaderOffsetAdjustment = useMemo(() => {
      if (isSetSearchGroupHeader) {
        return 136;
      } else {
        return 140;
      }
    }, [isSetSearchGroupHeader]);

    // 그룹 내 카메라 펼침 상태가 변경될 때마다 다시 계산하기 위해 메모이제이션 사용 안함
    const absoluteHeaderPosition = () => {
      if (mobile) {
        return (
          (buttonsRef?.current[filteredCams[filteredCams.length - 1].device.psn]
            ?.current?.offsetTop || 0) - 120
        );
      } else {
        return (
          (buttonsRef?.current[filteredCams[filteredCams.length - 1].device.psn]
            ?.current?.offsetTop || 0) - 115
        );
      }
    };

    const cardHeaderMarkup = useMemo(() => {
      return (
        <div>
          <div className={classes.profile}>
            <div className={classes.avatar}>
              <div
                style={{
                  position: "relative",
                  width: avartarDivWidth,
                  height: 34,
                }}
              >
                {avatarMarkup}
              </div>

              <div className={classes.cameraCountDiv}>
                <Typography
                  category="Default"
                  variant="Caption"
                  htmlColor={LightColors.primary["1"]}
                  style={{
                    wordBreak: "break-all",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {cameraCountText}
                </Typography>
              </div>
            </div>
          </div>
          <div className={classes.divider} />
          <div className={classes.status}>
            <div className={classes.noti}>
              {open ? (
                <KeyboardArrowDownIcon
                  onClick={() => {
                    setOpen(!open);
                    if (mobile) {
                      setTimeout(() => {
                        handleMobileMoveTop(cardRef);
                      }, 100);
                    } else {
                      setTimeout(() => {
                        handleMoveTop(cardRef);
                      }, 100);
                    }
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                  htmlColor="#2ea8e5"
                />
              ) : (
                <KeyboardArrowUpIcon
                  onClick={() => {
                    setOpen(!open);
                    if (mobile) {
                      setTimeout(() => {
                        handleMobileMoveTop(cardRef);
                      }, 100);
                    } else {
                      setTimeout(() => {
                        handleMoveTop(cardRef);
                      }, 100);
                    }
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                  htmlColor="#2ea8e5"
                />
              )}

              <Typography
                category="Default"
                variant="BodyBold"
                className={classes.groupTitle}
                htmlColor={LightColors.primary["2"]}
              >
                {t("Group")}: {group.GroupName}
              </Typography>
            </div>
          </div>
        </div>
      );
    }, [
      avartarDivWidth,
      avatarMarkup,
      cameraCountText,
      classes.avatar,
      classes.cameraCountDiv,
      classes.divider,
      classes.groupTitle,
      classes.noti,
      classes.profile,
      classes.status,
      group.GroupName,
      handleMobileMoveTop,
      handleMoveTop,
      mobile,
      open,
      t,
    ]);

    const handleOpenPanel = useCallback(
      ({ psn, height }: { psn: string; height: number }) => {
        if (cameraCardExtraHeight.find((v) => v.psn === psn)) {
          const newCameraCardExtraHeight = cameraCardExtraHeight.map((v) => {
            if (v.psn === psn) {
              v.height = height;
            }
            return v;
          });

          setCameraCardExtraHeight(newCameraCardExtraHeight);
        } else {
          setCameraCardExtraHeight([...cameraCardExtraHeight, { psn, height }]);
        }
      },
      [cameraCardExtraHeight]
    );

    return (
      <>
        <Card ref={cardRef} style={style} className={clsx(classes.root)}>
          {showFixedHeader && (
            <div
              className={clsx({
                [classes.openGroupHead]: open,
              })}
              style={{
                width: mobile ? 358 : 343,
                position: isAbsoluteHeader ? "absolute" : "fixed",
                top: isAbsoluteHeader
                  ? absoluteHeaderPosition()
                  : cardRef.current?.offsetTop &&
                    cardRef.current?.offsetTop < 10
                  ? searchGroupHeaderOffsetAdjustment
                  : headerOffsetAdjustment,
              }}
            >
              <div className={classes.groupHead}>{cardHeaderMarkup}</div>
            </div>
          )}

          {cardHeaderMarkup}

          <div
            className={clsx(classes.camList, classes.rootTransition, {
              [classes.panelClose]: !open,
            })}
            style={
              open
                ? {
                    height:
                      filteredCams.length * 208 +
                      24 +
                      cameraCardExtraHeight.reduce(
                        (acc, cur) => acc + cur.height,
                        0
                      ),
                    padding: "12px 0",
                  }
                : {}
            }
          >
            {filteredCams.map((camera, index) => {
              const fw = _.find(
                availableNewFws,
                (v, k) => k === camera.device.psn
              );

              return (
                <RenewalCameraItem
                  handleOpenPanel={handleOpenPanel}
                  onClickLocation={() => {}}
                  key={camera.device.psn}
                  className={classes.cameraItem}
                  camera={camera.device}
                  ref={buttonsRef.current[camera.device.psn]}
                  newFw={!!(fw?.blackvue || fw?.dmc200)}
                  onClickMore={() => onClickMore(camera.device)}
                  handleMenu={(menu) => handleMenu(camera.device, menu)}
                />
              );
            })}
          </div>
        </Card>
      </>
    );
  }
);
